import {
  appToastItems,
  clearAppToastItems,
  dismissAppToastItem,
  pushAppToastItem,
} from '~/utils/appToastSingleton'

export default defineNuxtPlugin((nuxtApp) => {
  const api = {
    items: appToastItems,
    push: pushAppToastItem,
    dismiss: dismissAppToastItem,
    clear: clearAppToastItems,
  }
  nuxtApp.provide('appToastItems', appToastItems)
  nuxtApp.provide('pushAppToast', pushAppToastItem)
  nuxtApp.provide('dismissAppToast', dismissAppToastItem)
  nuxtApp.provide('clearAppToasts', clearAppToastItems)
  globalThis.__LIP_APP_TOAST__ = api
})
